import {TimeSpan} from "../types/time-span";

export class Debounce {
    constructor(private readonly timeout: TimeSpan) {

    }

    private _timeoutRef: any = null;

    execute(callback: () => void) {
        clearTimeout(this._timeoutRef);
        this._timeoutRef = setTimeout(callback, this.timeout.totalMilliseconds);
    }

    dispose(): void {
        clearTimeout(this._timeoutRef);
    }
}